import axios from 'axios'
import { URLS } from '../../util/urls'
import tools from '../../util/tools'
import debugHelper from '../../util/debug'

const state = {
  /**
   * 硬件GPS信号
   */
  gps: {
    latitude: 30.3342485905,
    longitude: 120.3391485097,

    /**
     * 起点
     */
    src: {
      latitude: 30.14902257,
      longitude: 120.2559318932
    },

    /**
     * 终点
     */
    dest: {
      latitude: 30.14902257,
      longitude: 120.2559318932
    },
    /**
     * 途径点
     */
    navRoutes: [
      { name: 'A', latitude: 30.17989245, longitude: 120.2518068859 },
      { name: 'B', latitude: 30.1650396529, longitude: 120.3000322441 },
      { name: 'C', latitude: 30.3045633807, longitude: 120.6047137565 }
    ],
    isPump: false
  },
  /**
   * 坐标转换后的GPS信号
   */
  resultGPS: {
    data: {
      locations: '',
      src: {
        latitude: 30.14902257,
        longitude: 120.2559318932
      },
      dest: {
        latitude: 30.14902257,
        longitude: 120.2559318932
      },
      navRoutes: [
        { name: 'A', latitude: 30.17989245, longitude: 120.2518068859 },
        { name: 'B', latitude: 30.1650396529, longitude: 120.3000322441 },
        { name: 'C', latitude: 30.3045633807, longitude: 120.6047137565 }
      ]
    },
    status: ''
  },

  showTime: true
}

const getters = {
  getGPS: state => {
    return state.gps
  },
  getResultGPS: state => {
    return state.resultGPS.data
  },
  getGPSNavRoutes: state => {
    return state.gps.navRoutes
  },
  getShowTime: state => {
    return state.showTime
  }
}

const actions = {
  /**
   * 坐标转换
   * 其中第一个GPS数据为目标地址数据
   */
  convertCoordinate: ({ commit }, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: URLS.COORDINATE_CONVERT_URL,
        params: params.data,
        headers: {
          'Content-Type': 'application/json',
          ...params.authorization
        }
      })
        .then(resp => {
          commit('setResultGPS', {
            value: resp.data
          })
          resolve()
        })
        .catch(err => {
          err.type = 'error'
          err.prefix = 'location:'
          debugHelper.log('err')
          debugHelper.log(err)
          tools.showTips(this, err)
          reject()
          return
        })
    })
  },
  setShowTime: ({ commit }, payload) => {
    commit('setShowTime', payload)
  }
}

const mutations = {
  update: (state, payload) => {
    //再确定src与dest之前先用这俩
    state.gps.latitude = payload.latitude
    state.gps.longitude = payload.longitude

    //src
    state.gps.src.latitude = payload.src.latitude
    state.gps.src.longitude = payload.src.longitude

    //dest
    state.gps.dest.latitude = payload.dest.latitude
    state.gps.dest.longitude = payload.dest.longitude
    //清空数组
    state.gps.navRoutes.splice(0, state.gps.navRoutes.length)

    payload.navRoutes.forEach(navRoute => {
      state.gps.navRoutes.push(navRoute)
    })
  },
  setGPS: (state, payload) => {
    //再确定src与dest之前先用这俩
    state.gps.latitude = payload.latitude
    state.gps.longitude = payload.longitude

    //src
    state.gps.src.latitude = payload.src.latitude
    state.gps.src.longitude = payload.src.longitude

    //dest
    state.gps.dest.latitude = payload.dest.latitude
    state.gps.dest.longitude = payload.dest.longitude

    //清空数组
    state.gps.navRoutes.splice(0, state.gps.navRoutes.length)

    payload.navRoutes.forEach(navRoute => {
      state.gps.navRoutes.push(navRoute)
    })

    state.gps.isPump = payload.isPump ? payload.isPump : false
    state.gps.isReturning = payload.isReturning ? payload.isReturning : false
  },
  setResultGPS: (state, payload) => {
    state.resultGPS.data.locations = payload.value.data.locations

    //清空数组
    state.resultGPS.data.navRoutes.splice(
      0,
      state.resultGPS.data.navRoutes.length
    )
    var i = 0

    //数据格式:"locations":"120.344361,30.331891| 120.344361,30.331897"
    //其中第一个GPS数据为起点坐标数据, 第二个GPS数据为目标地址数据
    payload.value.data.locations.split('|').forEach(location => {
      var gpsTmp = location.split(',')
      if (i == 0) {
        state.resultGPS.data.src.longitude = gpsTmp[0]
        state.resultGPS.data.src.latitude = gpsTmp[1]
      } else if (i == 1) {
        state.resultGPS.data.dest.longitude = gpsTmp[0]
        state.resultGPS.data.dest.latitude = gpsTmp[1]
      } else {
        state.resultGPS.data.navRoutes.push({
          name: String.fromCharCode(65 /* 'A' */ + i - 2),
          longitude: gpsTmp[0],
          latitude: gpsTmp[1]
        })
      }
      i++
    })
    state.resultGPS.status = payload.value.status
  },
  setShowTime: (state, payload) => {
    state.showTime = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
